import React from "react";
import savers1 from '../../assets/image/severside.jpg';

function OtherPageTopBanner({ title, subtitle, buttonText }) {
  return (
    <div 
      className="p-5 text-center bg-image rounded-3 position-relative overflow-hidden"
      style={{
        backgroundImage: `url(${savers1})`,
        height: '400px',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Full Overlay */}
      <div 
        className="position-absolute top-0 start-0 w-100 h-100" 
        style={{ backgroundColor: '#07246667', zIndex: 1 }}
      ></div>

      {/* Content */}
      <div className="d-flex justify-content-center align-items-center h-100 position-relative" style={{ zIndex: 2 }}>
        <div className="text-white">
          <h1 className="mb-3">{title || "Heading"}</h1>
          {buttonText && (
            <a 
              className="btn btn-outline-light btn-lg"
              href="#!"
              role="button"
            >
              {buttonText}
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default OtherPageTopBanner;
